import type { PackageManager } from '@cli-types/core-engine/utils.js'

export function buildAddArgs(pm: PackageManager, deps: string[], dev: boolean): string[] {
  const devFlag = dev ? (pm === 'yarn' ? '--dev' : '-D') : ''

  switch (pm) {
    case 'pnpm':
      return ['add', ...(devFlag ? [devFlag] : []), ...deps]
    case 'yarn':
      return ['add', ...(devFlag ? [devFlag] : []), ...deps]
    case 'bun':
      return ['add', ...(devFlag ? [devFlag] : []), ...deps]
    default:
      return ['install', ...(devFlag ? [devFlag] : []), ...deps]
  }
}
